//#region types
import { DateRange } from "models/formTypes/util";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FormFieldConstants } from "utils/constants";
//#endregion
import { QueryStateHelper } from "utils/helpers";

const useQueryParamsHelper = (annualAccountsFinancialYear?: WintSuperkollAPIModel.FinancialYear) => {
  const getFinancialYearRangeSearchParamString = () => {
    if (!annualAccountsFinancialYear) {
      return "";
    }

    const queryStateHelper = QueryStateHelper.monthRangeQueryEncoder(
      FormFieldConstants.Accounting.FinancialReportFilter.MonthRange
    );
    const searchParams = new URLSearchParams("");

    const financialYearRange: DateRange = {
      start: new Date(annualAccountsFinancialYear.start),
      end: new Date(annualAccountsFinancialYear.end),
    };

    queryStateHelper.urlEncode(searchParams, undefined, financialYearRange);
    return `?${searchParams.toString()}`;
  };

  const getFinancialYearEndDateSearchParamString = (filterName: string) => {
    if (!annualAccountsFinancialYear) {
      return "";
    }

    const queryStateHelper = QueryStateHelper.dateQueryEncoder(filterName);
    const searchParams = new URLSearchParams("");

    queryStateHelper.urlEncode(searchParams, undefined, new Date(annualAccountsFinancialYear.end));
    return `?${searchParams.toString()}`;
  };

  return { getFinancialYearRangeSearchParamString, getFinancialYearEndDateSearchParamString };
};

export default useQueryParamsHelper;
